// @flow

import {type RecordFactory, type RecordOf, Record} from 'immutable';

import {
  type PresenceActions,
  PRESENCE_SUBSCRIBE,
  PRESENCE_UNSUBSCRIBE,
  RECEIVE_PRESENCE_MEMBER,
  REMOVE_PRESENCE_MEMBER,
  RECEIVE_PRESENCE_BEACON,
  RECEIVE_PRESENCE_ATTEND,
} from './actions';

import type {StoredPresenceMessageChannelDataType} from './types';

type StateShape = {
  subscriptions: {[string]: StoredPresenceMessageChannelDataType},
};

const StateFactory: RecordFactory<StateShape> = Record({subscriptions: {}});

export type RecordOfPresenceState = RecordOf<StateShape>;

export const presenceReducer = (
  state: RecordOfPresenceState = StateFactory(),
  action: PresenceActions
): RecordOfPresenceState => {
  switch (action.type) {
    case PRESENCE_SUBSCRIBE: {
      const {groups} = action;

      return state.set('subscriptions', {
        // $FlowFixMe
        ...state.get('subscriptions'),
        ...groups.reduce(
          (groups, group) => ({
            ...groups,
            [group.name]: {
              ...group,
              members: {},
            },
          }),
          {}
        ),
      });
    }

    case PRESENCE_UNSUBSCRIBE: {
      const {groups} = action;
      return state.set(
        'subscriptions',
        groups.reduce(
          (subscriptions, group) => {
            delete subscriptions[group];
            return subscriptions;
            // $FlowFixMe - no idea why flow doesnt accept the get here
          },
          {...state.get('subscriptions')}
        )
      );
    }

    case RECEIVE_PRESENCE_BEACON:
    case RECEIVE_PRESENCE_ATTEND:
    case RECEIVE_PRESENCE_MEMBER: {
      const {group, websocket_id, groupData} = action.data;
      const {memberPresenceTimeoutID} = action;

      return state.setIn(
        ['subscriptions', (group: string), 'members', websocket_id],
        {
          groupData,
          removalTimeoutID: memberPresenceTimeoutID,
        }
      );
    }

    case REMOVE_PRESENCE_MEMBER: {
      const {group, websocket_id} = action.data;
      return state.deleteIn([
        'subscriptions',
        (group: string),
        'members',
        websocket_id,
      ]);
    }

    default:
      return state;
  }
};
